import { useState } from 'react'

import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

import AddRoleModal from './AddRoleModal'

export interface AddRoleProps {
  disabledEmployeeIds: number[]
  onCreateRow: (viewerEmployeeSelection: EmployeesEmployeeSelectorInput) => void
  buttonCentered?: boolean
}

const AddRole = ({ disabledEmployeeIds, onCreateRow, buttonCentered }: AddRoleProps) => {
  const [employeeSelection, setEmployeeSelection] = useState<EmployeeSelectorV2MultiSelectState>({
    type: 'manual',
    ids: [],
  })

  const disableSubmitButton = () => {
    if (employeeSelection.type === 'manual') {
      return employeeSelection.ids.length === 0
    }
    return false
  }

  const onClose = () => {
    setEmployeeSelection({ type: 'manual', ids: [] })
  }

  const onSubmit = () => {
    onCreateRow(employeeSelection)
    setEmployeeSelection({ type: 'manual', ids: [] })
  }

  const onSelectEmployees = (state: EmployeeSelectorV2MultiSelectState) => {
    setEmployeeSelection(state)
  }

  return (
    <AddRoleModal
      onClose={onClose}
      onSubmit={onSubmit}
      disableSubmitButton={disableSubmitButton}
      disabledEmployeeIds={disabledEmployeeIds}
      onSelectEmployees={onSelectEmployees}
      buttonCentered={buttonCentered}
    />
  )
}

export default AddRole
